
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqlwn6as9h_tcdtpzgAoHpRJK3SyUX9RuOlUSGxNDx_8oMeta } from "/codebuild/output/src2927934346/src/src/pages/faq.vue?macro=true";
import { default as menujdvi7cYLJ_K5HgG3DlwW3JlpuiY8Mok9ay9ddXJMVhoMeta } from "/codebuild/output/src2927934346/src/src/pages/menu.vue?macro=true";
import { default as indexMY_uLr6IEFQhkLfUhvvnUFT1GfVIUhdscRG6Fxi7lZgMeta } from "/codebuild/output/src2927934346/src/src/pages/index.vue?macro=true";
import { default as contact4oRutXCYzF2VD9Oc61j4qDCz712YGm1t6cd3VuRUbL8Meta } from "/codebuild/output/src2927934346/src/src/pages/contact.vue?macro=true";
import { default as tutorialQMgbOrfA5dkk4rDLlr5_45p7WoxggduSfX8b_45D89YtWXgMeta } from "/codebuild/output/src2927934346/src/src/pages/tutorial.vue?macro=true";
import { default as agreementTEyzroJCAihUQp8Nm1_t1OACUFoW3v0eNF6K9oHvw1oMeta } from "/codebuild/output/src2927934346/src/src/pages/agreement.vue?macro=true";
import { default as about_45passcxDP_uEWwQAJ7UwGIuPJWwb5C_45j0Ah_4TXnjZwBJz3EMeta } from "/codebuild/output/src2927934346/src/src/pages/about-pass.vue?macro=true";
import { default as indexCJ_45sAV99NVcCKaa3WzaMHuH1mrK32jkJgm5ZjmVBNEcMeta } from "/codebuild/output/src2927934346/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93_455EJuvDv8y6Ofv9Wz98w2HP4INkUSVAwAhpSYKSnfC4Meta } from "/codebuild/output/src2927934346/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance5kt_WLIuSJXx6XQLt9J4wdHuKH6N7oQmUFANmxfXezYMeta } from "/codebuild/output/src2927934346/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93xsMk9LN_Da5yAKDGAIkw2J3vXI_45bVGIFzCnEijVdtm4Meta } from "/codebuild/output/src2927934346/src/src/pages/notice/[id].vue?macro=true";
import { default as indexRtI_FK8SmbUlKExjbUEQtHEtddc0tGRgQ8n_45ioqp4lAMeta } from "/codebuild/output/src2927934346/src/src/pages/coupon/index.vue?macro=true";
import { default as indexaOz3rOau_451_45Uj2Y6oi_45HhZPOXgL4G8qYbBgFG9ZhGpwMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/index.vue?macro=true";
import { default as indexcgL3vdzsiDo3qFd0wVRhw62E_s4Ijw9scYxgLdvLwKkMeta } from "/codebuild/output/src2927934346/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93Ah07RZ7GKryNkhGyI_YQvaNwmhx8cTGxU3L_45tpCyLbQMeta } from "/codebuild/output/src2927934346/src/src/pages/parking/[id].vue?macro=true";
import { default as indexQHaS_ewiwGdmlujmEMQR2uPjiYBOYOOsf453H7FzHGkMeta } from "/codebuild/output/src2927934346/src/src/pages/history/index.vue?macro=true";
import { default as index5wdR_n9nrb1BVv6fDoFQ1XdG_45YMqg0hZiSccPyeJ1r8Meta } from "/codebuild/output/src2927934346/src/src/pages/monthly/index.vue?macro=true";
import { default as indexZtxsN8NOLcZCseMvIA5F_GEYq8FWQFckY5hGry0ETA0Meta } from "/codebuild/output/src2927934346/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexJVUcEIcV4NDO9Aa8OrEFFiKzLYKqD3CDLbBSYURsJboMeta } from "/codebuild/output/src2927934346/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviSvqIyMjOaF44BDP32FA_45QMT5Oht5bS8nK_456k3vmS7f8Meta } from "/codebuild/output/src2927934346/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit1sXVI4EApUUzn_y7Lf6VId8v9qLr_iG3r4Q9MiJpgpAMeta } from "/codebuild/output/src2927934346/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementnGKfl9Fmm5QeSQuZhZbDK28PqHD92kTALuIoMgbjvg0Meta } from "/codebuild/output/src2927934346/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexOzpM6Fo478L4V1Y3Nh8E37DADByhRnV3RkGu_45HyjL7gMeta } from "/codebuild/output/src2927934346/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dB08KNRENfumOgUtoPG6sjep6R3_45d68gdr_45HUmg9QIU8Meta } from "/codebuild/output/src2927934346/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm0O355B8yKp_MWGTuKi_VQnQKSUv8suca2k0I4CqptNkMeta } from "/codebuild/output/src2927934346/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexQQXaeesK0iRSPEl_KrGsHdkw1jSOtl1zr2w_4589funQEMeta } from "/codebuild/output/src2927934346/src/src/pages/card/create/index.vue?macro=true";
import { default as index0F_xjMG_3LjRAONUWXDU_FBS0Hx7xWacRpnfPwjS_45D0Meta } from "/codebuild/output/src2927934346/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmOSKSQjsoFpJrkrAogg_F9bPdaqci46vJG5E_45EqV43T8Meta } from "/codebuild/output/src2927934346/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmTFfEjaLAA_La0VQA_45UYXTe7hxUA1B2Cgnmf7AduquKkMeta } from "/codebuild/output/src2927934346/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeSPkSL2ZkvTQQt5dNTkBbLd1r6v_U3IlEBj1h4Uli7rYMeta } from "/codebuild/output/src2927934346/src/src/pages/membership/complete.vue?macro=true";
import { default as register5CU5S171ze69ojKH96IopouRU10YFyTrYNPe18F0A2gMeta } from "/codebuild/output/src2927934346/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93_ZclDVs60WxTUCrgyknRUoHCBdaLhVz4XXcAqr1rUIEMeta } from "/codebuild/output/src2927934346/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm2vDA_45rG7c_FxNgPZ7isUYzBS1fz98l7eRp6lxGOqmfoMeta } from "/codebuild/output/src2927934346/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93zbTLQOnKV3ucQcR9MwKqM0BCZVg1yZ4hkJPzs28uZJ0Meta } from "/codebuild/output/src2927934346/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexhGbUZripmVsMV5tgpgIuopzAdokCK56mu_hwMsTp8wEMeta } from "/codebuild/output/src2927934346/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code2g_K6ivxMBLp4so8PtwG7O6EdtNsGu2roXXlPMHABOYMeta } from "/codebuild/output/src2927934346/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeMU6slI423oPKUIEYFkR0VWUYErMzOPpsFuf1gRb3meoMeta } from "/codebuild/output/src2927934346/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete5hK1UKby0JkeaosUS4naPt3zNowECpE8Ax1D3d8cKXEMeta } from "/codebuild/output/src2927934346/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registermIoLvmfqUOm6AXGxyHOcU67n0m8n2hUcNScsmAPylSoMeta } from "/codebuild/output/src2927934346/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeptg7jFvxsnvClKaEAG7cbArhXNIZkH_Ng5T0ZAW2EXAMeta } from "/codebuild/output/src2927934346/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index1UClNFDqNpwvSzHywkE610PTHvZV_456_EkS6v302M698Meta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmbXTGXbqBmVwuFTJTxwT_45I6TSudiUWU9Rp_jdIZd4oFwMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completedSEsKzPNRfTlAkgV2YQJ6KDQr7qIrbHy7WL6K4g3VIgMeta } from "/codebuild/output/src2927934346/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexOVgwH4OLfJM6bj1v2EMur_45ujCN7ebz4FGoZQwIGL7oQMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93Mdsov1i7z7CyNwVvCOdk5jpOcmIVDM_45_45KIvlNkyg00QMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete1uy08qX_45kgf_45SczWVmlquMrkWLIoAtJqKBDBEYIN8HMMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasGteT_b38vGa1wRrHb2Qzcy2zSwQ8SFHM93IuJstYbnAMeta } from "/codebuild/output/src2927934346/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleeHtrtmpsGNTNrgAe8An0Pm7kqNEdSEXSZYBSoIHfg98Meta } from "/codebuild/output/src2927934346/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailbFe0C7e6_Ef8Q2WZYSoGWd9ibIf0YzkECIZqKOyfVdwMeta } from "/codebuild/output/src2927934346/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmS_451sZDZedVAr7sgSpa_45iTIDiBGxGE9GgU8khtTw7fPgMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentibyfT76XOYcKXxPNRCARyx0_456UC45LFF9_458qBiCjbEUMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmZhaT8sos2UX8_KA2P9zDK8MQb3ki_454pDlDlr8Nhb6HMMeta } from "/codebuild/output/src2927934346/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateHLXeiUBUR0VnUKdGWNYOBGaHxr1g7POv7wNVacTldRMMeta } from "/codebuild/output/src2927934346/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completePoXn4fqd9IcMyy2_45O9rOOeuqsDt0qQdg_ek_7xg0UzMMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codezI9Jl6NmBkbu78Tz_n4KqY4tkKEJ_45bqgOl9LvjDiSMwMeta } from "/codebuild/output/src2927934346/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordYuMNFLHSjGiRRrnF2A_45oI1VNAH5GUOSOwxEsCpgBh2kMeta } from "/codebuild/output/src2927934346/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasX3tz7rOk1TrV7z9KSVvsTIPOZl3nwo_45pChW_45IVCuAfwMeta } from "/codebuild/output/src2927934346/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register_45ITPGGqyNUe891Rq8wfgIMy1eZaTkv8ZqAXxi0YbxQ4Meta } from "/codebuild/output/src2927934346/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeko_45sNIvxgwwK9kUIQY31yAUMF5_45FIczOAUmK8w2Fn6QMeta } from "/codebuild/output/src2927934346/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index0vXau_mXmUCJ5dFt4ux9KH4vdvDPIuoWoADAUW_45CWGMMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexs0cCbnMlRDRgTkuBBqR2qDTfLwmGBg6_Oit4qW21K2kMeta } from "/codebuild/output/src2927934346/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index_J3jRZET0hTK3RkAKMreG6e95kEmshyHZE5IcZbM9zQMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexb9cy4Xq_45BOP67e1b5HX9UtosvdMzTTSXCO6N_45FpQ1VQMeta } from "/codebuild/output/src2927934346/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateBgUkv2cuWauHHFxOvs_3niuSGhcUL_EYWrNqt_XCgH4Meta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete52bw5c508crcH9cxx2QQM5ZcHrXs1EptG9KdhEkSGlwMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmcVLoVFNtUf6WJfPm_45HOnv_45d2PC79mkXKKYQ8lZQ9DQkMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexdZRFUNBP0wD08_45tvTF5jCnWX5Nl_45lIjcAyat4FtZw3IMeta } from "/codebuild/output/src2927934346/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeGaqyo7LDfqVJIkI6Rnjv_K5RRiljO3vj8S6d2MhqlwMMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatetHlOxfJDBweR_455AJ_45zor3Q1l35HXUHm5vnXPJLgNxc0Meta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexmHdxz_W492asIQ3_45DVS5l8m8xrBayWIrkWippa2ZK_45QMeta } from "/codebuild/output/src2927934346/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexv2_s0_45ZnGBe7tragW_uaFReLpR3wWo21yV9Ac94hubYMeta } from "/codebuild/output/src2927934346/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeCHTpAt04ccC5oJzk3tzMgJuraV64e9BRXl_45i1WEJd30Meta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexQhfZdOy90t9xC2NpUUsX9sFv8l7fC6QkSGAJOJMtHYIMeta } from "/codebuild/output/src2927934346/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeTwNUkgSL5z5aYP5IemQu8zJOvId7UI_45vxNt9kpGSG1cMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexXBjnIl8lpzbZrmQaAf9wm_45PwPFJ4Wlfp0cS0QkKztEoMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexJ4_45K2yD6bDIeOS_451oDrUhTEuXlgtwzGLkcST0h8bFkUMeta } from "/codebuild/output/src2927934346/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexqDBAsjRxW1LEzFmyJAdeNZq_aAi5pJtRjKJ_45tJoms2EMeta } from "/codebuild/output/src2927934346/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update8bhCFy8F3F0EaXWB5tmDPAJW_456PQamQBgTG43bZQ77cMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmlJuTLQ1k0kM7SmnUpyQMm7hJHt3Tb_axmmYiDVS_XvgMeta } from "/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menujdvi7cYLJ_K5HgG3DlwW3JlpuiY8Mok9ay9ddXJMVhoMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexMY_uLr6IEFQhkLfUhvvnUFT1GfVIUhdscRG6Fxi7lZgMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexRtI_FK8SmbUlKExjbUEQtHEtddc0tGRgQ8n_45ioqp4lAMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2927934346/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexQHaS_ewiwGdmlujmEMQR2uPjiYBOYOOsf453H7FzHGkMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2927934346/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexZtxsN8NOLcZCseMvIA5F_GEYq8FWQFckY5hGry0ETA0Meta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexJVUcEIcV4NDO9Aa8OrEFFiKzLYKqD3CDLbBSYURsJboMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexQQXaeesK0iRSPEl_KrGsHdkw1jSOtl1zr2w_4589funQEMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmOSKSQjsoFpJrkrAogg_F9bPdaqci46vJG5E_45EqV43T8Meta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmTFfEjaLAA_La0VQA_45UYXTe7hxUA1B2Cgnmf7AduquKkMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2927934346/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeSPkSL2ZkvTQQt5dNTkBbLd1r6v_U3IlEBj1h4Uli7rYMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register5CU5S171ze69ojKH96IopouRU10YFyTrYNPe18F0A2gMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm2vDA_45rG7c_FxNgPZ7isUYzBS1fz98l7eRp6lxGOqmfoMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code2g_K6ivxMBLp4so8PtwG7O6EdtNsGu2roXXlPMHABOYMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeMU6slI423oPKUIEYFkR0VWUYErMzOPpsFuf1gRb3meoMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete5hK1UKby0JkeaosUS4naPt3zNowECpE8Ax1D3d8cKXEMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registermIoLvmfqUOm6AXGxyHOcU67n0m8n2hUcNScsmAPylSoMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmbXTGXbqBmVwuFTJTxwT_45I6TSudiUWU9Rp_jdIZd4oFwMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completedSEsKzPNRfTlAkgV2YQJ6KDQr7qIrbHy7WL6K4g3VIgMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexOVgwH4OLfJM6bj1v2EMur_45ujCN7ebz4FGoZQwIGL7oQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete1uy08qX_45kgf_45SczWVmlquMrkWLIoAtJqKBDBEYIN8HMMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleeHtrtmpsGNTNrgAe8An0Pm7kqNEdSEXSZYBSoIHfg98Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailbFe0C7e6_Ef8Q2WZYSoGWd9ibIf0YzkECIZqKOyfVdwMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmS_451sZDZedVAr7sgSpa_45iTIDiBGxGE9GgU8khtTw7fPgMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentibyfT76XOYcKXxPNRCARyx0_456UC45LFF9_458qBiCjbEUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmZhaT8sos2UX8_KA2P9zDK8MQb3ki_454pDlDlr8Nhb6HMMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completePoXn4fqd9IcMyy2_45O9rOOeuqsDt0qQdg_ek_7xg0UzMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codezI9Jl6NmBkbu78Tz_n4KqY4tkKEJ_45bqgOl9LvjDiSMwMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordYuMNFLHSjGiRRrnF2A_45oI1VNAH5GUOSOwxEsCpgBh2kMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register_45ITPGGqyNUe891Rq8wfgIMy1eZaTkv8ZqAXxi0YbxQ4Meta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeko_45sNIvxgwwK9kUIQY31yAUMF5_45FIczOAUmK8w2Fn6QMeta || {},
    component: () => import("/codebuild/output/src2927934346/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2927934346/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]